import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromAlgoliaSearch from './+state/algolia-search.reducer';
import { AlgoliaSearchEffects } from './+state/algolia-search.effects';
import { AlgoliaSearchFacade } from './algolia-search/algolia-search.facade';
import { SearchClientService } from './search-client.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromAlgoliaSearch.ALGOLIA_SEARCH_FEATURE_KEY, fromAlgoliaSearch.reducer),
    EffectsModule.forFeature([AlgoliaSearchEffects]),
  ],
  providers: [AlgoliaSearchFacade, SearchClientService],
})
export class AlgoliaDomainModule {}
